import { SubscriptionItemModel } from "../../entities/billing";
import { BaseODataRepository } from "../BaseODataRepository";

export class SubscriptionItemODataRepo extends BaseODataRepository<SubscriptionItemModel> {
  protected baseUrl = `/OData/subscriptionitems`;
}

export default SubscriptionItemODataRepo;
